import chunk from 'lodash/chunk';
export function getLinkDetailArrays(links, numberOfColumns) {
  var lengthOfArray = links.length;
  var remainder = lengthOfArray % numberOfColumns;
  var longestColumnLength = (lengthOfArray - remainder) / numberOfColumns + remainder;
  var numberOfLongColumns = numberOfColumns - 1;
  var shortestColumnLength = lengthOfArray - numberOfLongColumns * longestColumnLength;

  while (longestColumnLength - shortestColumnLength > numberOfLongColumns) {
    longestColumnLength -= 1;
    shortestColumnLength += numberOfLongColumns;
  }

  return chunk(links, longestColumnLength);
}